module.exports = __webpack_public_path__ + "img/fan_open.7efea304.png";